import { render, staticRenderFns } from "./IconCircles.vue?vue&type=template&id=5025038e&functional=true"
import script from "./IconCircles.vue?vue&type=script&lang=js"
export * from "./IconCircles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports